<template>
  <div>
    <el-dialog
      :title="`Podgląd - ${simpleFormData.timestamp}`"
      width="70vw"
      :visible.sync="dialogFormVisible"
    >
      <div v-loading="loading" class="sections">
        <div v-for="(section, i) in formData.sections" :key="i">
          <h2 class="section__title">Sekcja: {{ section.name }}</h2>
          <div v-for="(field, i) in section.fields" :key="i">
            <strong class="field__label">
              {{ i + 1 }}. {{ field.label }}
            </strong>
            <p>
              <span v-if="field.answer.value === 'true'">
                <i class="fa fa-check"></i>
              </span>
              <img
                v-else-if="field.answer.kind === 'photo'"
                class="field__thumbnail"
                :src="field.answer.value"
                alt=""
              />
              <span v-else>
                {{ field.answer.value }}
              </span>
            </p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$emit('previousPreview')"><</el-button>
        <el-button @click="$emit('nextPreview')">></el-button>
        <el-button @click="cancelForm()">Zamknij</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { CustomForm } from '@/api'

export default {
  data() {
    return {
      errors: {},
      loading: false,
      dialogFormVisible: false,
      simpleFormData: {},
      formData: {
        sections: []
      }
    }
  },
  props: ['bus'],
  mounted() {
    this.bus.$on('openPreviewDialog', this.openDialog)
  },
  methods: {
    openDialog(simpleFormData) {
      this.loading = true
      this.simpleFormData = simpleFormData
      this.formData = { sections: [] }
      this.fetchData()
      this.dialogFormVisible = true
    },
    cancelForm() {
      this.dialogFormVisible = false
      this.$emit('cancel')
    },
    fetchData() {
      this.loading = true
      CustomForm.fetchFormData(this.simpleFormData.id).then(response => {
        this.formData = response.data
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.sections {
  min-height: 200px;
}

.section {
  &__title {
    font-size: 24px;
    font-weight: 300;
  }
}

.field {
  &__label {
    font-size: 14px;
  }

  &__thumbnail {
    max-width: 200px;
  }
}
</style>
